import type { FinancesDateRangeParams } from './apiHelpers';
import { type DateFilterOption, getEarningsChartTitle } from './dateRange';
import {
  useFinancesEarningsByTable,
  useFinancesEarningsTimeseries,
  useFinancesRefundBreakdown,
  useFinancesSummary,
} from './hooks';
import { SummaryCards } from './SummaryCards';
import { EarningsByPeriodChart } from './EarningsByPeriodChart';
import { EarningsByTable } from './EarningsByTable';
import { RefundBreakdownChart } from './RefundBreakdownChart';
import styles from './FinancesOverview.scss';

export interface FinancesOverviewProps {
  dateFilter: DateFilterOption;
  dateRange: FinancesDateRangeParams;
  compareEnabled: boolean;
}

export const FinancesOverview = ({
  dateFilter,
  dateRange,
  compareEnabled,
}: FinancesOverviewProps) => {
  const { data: summary } = useFinancesSummary(dateRange);
  const { data: earningsTimeseries } = useFinancesEarningsTimeseries(
    dateRange,
    compareEnabled,
  );
  const { data: earningsByTable = [] } = useFinancesEarningsByTable(dateRange);
  const { data: refundBreakdown } = useFinancesRefundBreakdown(dateRange);

  return (
    <div className={styles.overview}>
      <SummaryCards
        dateFilter={dateFilter}
        grossEarnings={summary?.grossEarnings}
        netEarnings={summary?.netEarnings}
        refunds={summary?.refunds}
        refundCount={summary?.refundCount}
        timeseriesBuckets={earningsTimeseries?.buckets}
      />

      <EarningsByPeriodChart
        buckets={earningsTimeseries?.buckets ?? []}
        granularity={earningsTimeseries?.granularity}
        previousBuckets={earningsTimeseries?.previousBuckets}
        title={getEarningsChartTitle(earningsTimeseries?.granularity)}
      />

      <div className={styles.bottomRow}>
        <EarningsByTable rows={earningsByTable} />
        <RefundBreakdownChart
          buckets={refundBreakdown?.buckets ?? []}
          granularity={refundBreakdown?.granularity}
        />
      </div>
    </div>
  );
};
